import Cookies from 'js-cookie';
import registry from '~/library/store/src/registry';
import { GET_CORE_CONFIG } from './actions';

export const coreState = {
  isLoggedIn: false,
  isLoading: false,
  experiments: []
};

export default function reducer(state = coreState, action = {}) {
  const { type, payload } = action;
  const partnerString = Cookies.get('PartnerObject');
  let partnerObj = {};
  if (partnerString !== undefined && partnerString !== '') {
    partnerObj = JSON.parse(partnerString);
  }

  switch (type) {
    case '@@EXPERIMENT_USER_BUCKETED':
      return {
        ...state,
        experiments: payload?.experiments
      };

    case `${GET_CORE_CONFIG}_LOADING`:
      return {
        ...state,
        isLoading: true
      };

    case `${GET_CORE_CONFIG}_SUCCESS`:
      return {
        ...state,
        phoneNumber: partnerObj?.partnerDirectPhoneNumber?.replace(/\./g, '-'),
        isLoggedIn: payload?.hasProfile,
        isUserBeingImpersonated: payload?.isUserBeingImpersonated,
        userId: payload?.userId,
        email: payload?.email,
        name: payload?.name,
        isLoading: false
      };

    case `${GET_CORE_CONFIG}_ERROR`:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: payload
      };

    default:
      return state;
  }
}

registry.register('core', reducer, coreState);
